module.exports = __webpack_public_path__ + "img/logo.fb5fa047.png";